/** Open Stripe Checkout / Portal in the same tab so success_url returns cleanly. */
export async function openExternalUrl(url: string): Promise<void> {
  const g = globalThis as { location?: { assign: (href: string) => void } };
  if (!g.location?.assign) {
    throw new Error('Cannot open billing URL outside the browser');
  }
  g.location.assign(url);
}
